module.exports = __webpack_public_path__ + "static/img/6696_phase_function_Paper_PointsHejduk_Prediction.04fd30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6696_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 9CwD
// module chunks = 0